import { useParams } from 'react-router-dom';

const useTypedParams = <T>(): T => useParams() as unknown as T;

export default useTypedParams;
